export default __webpack_public_path__ + "static/media/BYD.283c1464.png";